// 创建/复制/编辑需求表单相关的 mixin
export default {
  computed: {
    pageType() {
      if (this.$route.name === 'butler.edit-demand') return 'update'
      // 创建：包括拷贝/素材审核跳转
      return 'create'
    },

    // 从素材审核（SS 素材）跳转过来的
    reviewId() {
      return this.$route.query.review_id
    },

    // 素材来源是 SS（只有从素材审核跳转过来的素材其来源才可能是 SS）
    isFromSS() {
      return this.demand.material_source === 3
    },

    copyId() {
      return this.$route.query.copy_id
    },

    // 需求归属=大媒体
    isBigMedia() {
      return this.demand.category === 'media'
    },
    // 需求归属=mintegral
    isMintegral() {
      return this.demand.category === 'mintegral'
    },
    // 需求归属=设计项目
    isDesign() {
      return this.demand.category === 'design'
    },

    // 需求类型=交互素材
    isInteractiveCreation() {
      return this.demand.type === 1
    },

    // 需求类型=非交互素材
    isNonInteractiveCreation() {
      return this.demand.type === 2
    },

    // 非交互素材+大媒体
    isNoninteractiveAndBigMedia() {
      return this.isNonInteractiveCreation && this.isBigMedia
    },

    // 非交互素材+大媒体+MTG
    isNoninteractiveAndBidMediaAndMTG() {
      return this.isNonInteractiveCreation && (this.isBigMedia || this.isMintegral)
    },

    // 是否付费
    isPay() {
      return this.demand.is_pay === 1
    },

    hasSelectCurrency() {
      return this.isUsdSettlement || this.isCnySettlement
    },

    // 是否预付
    isPrepaid() {
      return this.demand.is_prepaid === 1
    },

    // 是否是美元结算
    isUsdSettlement() {
      return this.demand.currency === 1
    },

    // 是否是人民币结算
    isCnySettlement() {
      return this.demand.currency === 2
    }
  }
}
